import { render, staticRenderFns } from "./DataTypeManager.vue?vue&type=template&id=2415f47e&scoped=true"
import script from "./DataTypeManager.vue?vue&type=script&lang=ts"
export * from "./DataTypeManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2415f47e",
  null
  
)

export default component.exports